import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";
import { startCase } from "lodash";
import {
  formatValueDynamically,
  getFormattedValue,
} from "../../../../utils/previewValueFormatterUtils";

interface UserProfileCardProps {
  params: Record<string, string | boolean | string[]>;
}

const USER_STATIC_FIELDS = {
  name: {
    label: t("help_widget.copilot.confirmation_card.name"),
    type: "string",
  },
  email: {
    label: t("help_widget.copilot.confirmation_card.email"),
    type: "string",
  },
  locale: {
    label: t("help_widget.copilot.confirmation_card.locale"),
    type: "string",
  },
  time_zone: {
    label: t("help_widget.copilot.confirmation_card.time_zone"),
    type: "string",
  },
  make_my_email_public: {
    label: t("help_widget.copilot.confirmation_card.make_my_email_public"),
    type: "boolean",
  },
  messaging_enabled: {
    label: t("help_widget.copilot.confirmation_card.messaging_enabled"),
    type: "boolean",
  },
  visible_in_member_directory: {
    label: t(
      "help_widget.copilot.confirmation_card.visible_in_member_directory",
    ),
    type: "boolean",
  },
};

export const UserProfileCard = ({ params }: UserProfileCardProps) => {
  const staticAttributes = Object.entries(USER_STATIC_FIELDS).map(
    ([key, { label, type }]) => ({
      label,
      value: key in params ? getFormattedValue(params[key], type) : null,
    }),
  );

  const dynamicAttributes = Object.entries(params)
    .filter(([key, value]) => !(key in USER_STATIC_FIELDS) && value != null)
    .map(([key, value]) => ({
      label: startCase(key),
      value: formatValueDynamically(value),
    }));

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.title_user_profile")}
      attributes={[...staticAttributes, ...dynamicAttributes]}
    />
  );
};
